import type { WorkOrderChangeSeasonData, WorkOrderChangeSeasonTotalData, WorkOrderChangeTotalData } from 'gql/graphql';
import { formatNumberToRu } from 'utils';

import type { ColDef } from 'ag-grid-community';
import type { CellClassParams, ValueFormatterParams } from 'ag-grid-community/dist/types/core/entities/colDef';

type TSeasonValueGetter = {
    id: number;
    key: keyof WorkOrderChangeSeasonTotalData;
    costRounding: number;
};

type TSeasonColumn = {
    seasons: WorkOrderChangeSeasonData[];
    name: string;
    costRounding: number;
    valueKey: keyof WorkOrderChangeSeasonTotalData;
};

export const cellClass = (cellClassParams: CellClassParams<WorkOrderChangeTotalData>) => {
    const headLineClass = cellClassParams.data?.isHeadLine ? 'head-line' : 'ordinary-line';

    return cellClassParams.colDef.field === 'name' ? [headLineClass] : [headLineClass, 'ag-right-aligned-cell'];
};

export const getSeasonValueByIdAndKey =
    ({ key, costRounding, id }: TSeasonValueGetter) =>
    ({ data }: { data: WorkOrderChangeTotalData }) => {
        const currentSeason = data?.seasonTotals?.find((season) => season.seasonId === id);

        return formatNumberToRu(currentSeason?.[key], costRounding) ?? '';
    };

export const getSeasonColumns = ({ seasons, valueKey, costRounding, name }: TSeasonColumn): ColDef[] =>
    seasons.map((season) => ({
        cellClass,
        headerName: `Сезон ${season.year}, ${name}`,
        flex: 1,
        type: 'numericColumn',
        minWidth: 200,
        valueGetter: getSeasonValueByIdAndKey({
            id: season.id,
            key: valueKey,
            costRounding,
        }),
    }));

export const getFormattedValue =
    (costRounding: number) =>
    ({ value }: ValueFormatterParams) =>
        formatNumberToRu(value, costRounding) ?? '';
